import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    inputContainer: {
        width: '100%',
        padding: '2px',
        borderRadius: '4px',
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: '1px',
        borderColor: "#afafb3",
        height:'41px'
    },
    inputContainerDisabled: {
        backgroundColor:'#e0e0e0'
    },
    input: {
        width: '100%',
        height: '100%',
        outline: 'none',
        paddingLeft: '10.5px',
        paddingTop: '10.5px',
        paddingBottom: '9.625px',
        backgroundColor: "#ffffff",
        borderStyle: "none",
        borderWidth: 0,
        borderColor: "#ffffff",
        fontSize: '16px',
        fontWeight: "normal",
        fontStyle: "normal",
        letterSpacing: '.21px',
        color: "#888888",
        '&:disabled':{
            backgroundColor:'#e0e0e0',
            color: "#4f4f4f"
        },
        '&::placeholder': {
            color: "#A8A8A8"
        }
    },

    inputContainerPhone: {
        padding: '2px',
        borderRadius: '4px',
        backgroundColor: "#ffffff",
        borderStyle: "solid",
        borderWidth: '1px',
        borderColor: "#afafb3",
        height:'41px'
    },
    inputContainerDisabledPhone: {
        backgroundColor : '#ededed'
    },
    inputForTime: {
        width: '106px',
        height: '42px',
        outline: 'none',
        paddingLeft: '10.5px',
        paddingTop: '10.5px',
        paddingBottom: '9.625px',
        backgroundColor: "#ffffff",
        borderStyle: "none",
        borderWidth: 0,
        borderColor: "#ffffff",
        fontSize: '16px',
        fontWeight: "normal",
        fontStyle: "normal",
        letterSpacing: '.21px',
        color: "#888888",
        '&:disabled':{
            backgroundColor:'#e0e0e0',
            color: "#4f4f4f"
        },
        '&::placeholder': {
            color: "#A8A8A8"
        }
    },
    inputContainerTime: {
        width: '108px',
        borderColor: '#afafb3',
        borderStyle: "solid",
        borderWidth: '1px',
        borderRadius: '4px',
        backgroundColor: "#ffffff"
    },
}));

export default function LoginTextField(props){
    const {id, name, placeholder, type, onChange, value, required, defaultValue, disabled, readOnly, maxCharacters,minCharacters, onClick, onInput, inputMode, pattern, phoneField, width, timeField} = props;
    const styles = useStyles();
    if(!phoneField && !timeField) {
        return (
            <div className={styles.inputContainer + (disabled ? ' ' + styles.inputContainerDisabled : '')}>
                <input
                data-testid={id}
                id={id}
                disabled={disabled}
                readOnly={readOnly}
                required={required}
                autoComplete="off"
                className={styles.input}
                type={type ? type : 'text'}
                placeholder={placeholder}
                onChange = {onChange}
                onClick = {onClick}
                onInput = {onInput}
                defaultValue={defaultValue}
                value={value ? value : ''}
                maxLength={maxCharacters}
                minLength={minCharacters}
                inputMode={inputMode}
                pattern={pattern}
                autoCorrect="off"
                autoCapitalize="none"
                />
            </div>
        );
    } else if(timeField){
        return (
            <div className={styles.inputContainerTime + (disabled ? ' ' + styles.inputContainerDisabled : '')}>
                <input
                data-testid={id}
                id={id}
                disabled={disabled}
                readOnly={readOnly}
                required={required}
                autoComplete="off"
                className={styles.inputForTime}
                type={type ? type : 'text'}
                placeholder={placeholder}
                onChange = {onChange}
                onClick = {onClick}
                onInput = {onInput}
                defaultValue={defaultValue}
                value={value ? value : ''}
                maxLength={maxCharacters}
                minLength={minCharacters}
                inputMode={inputMode}
                pattern={pattern}
                autoCorrect="off"
                autoCapitalize="none"
                />
            </div>
        );

    } else {
        const fieldWidth = width ? {width: width} : {};
        return (
            <div className={styles.inputContainerPhone + (disabled ? ' ' + styles.inputContainerDisabledPhone : '')}>
                <input
                    style={fieldWidth}
                    data-testid={id}
                    id={id}
                    name={name}
                    disabled={disabled}
                    readOnly={readOnly}
                    required={required}
                    className={styles.input}
                    type={type ? type : 'text'}
                    placeholder={placeholder}
                    onChange = {onChange}
                    onClick = {onClick}
                    onInput = {onInput}
                    defaultValue={defaultValue}
                    value = {value}
                    onFocus={(event) => { event.target.setAttribute('autocomplete', 'off'); }}
                    maxLength={maxCharacters}
                    onPaste={(e) => {
                        e.preventDefault();
                        return false;
                    }}
                />
            </div>
        )
    }
}